import { render } from "./IconItemCategoryGift.vue?vue&type=template&id=6358afc5"
import script from "./IconItemCategoryGift.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryGift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__